import React, { useEffect, useState } from "react";
import { api, fmtEUR } from "../../lib/api";
import { Link } from "react-router-dom";

export default function SponsorDashboard() {
  const [sponsorships, setSponsorships] = useState([]);

  useEffect(() => {
    api.get("/me/sponsorships").then((r) => setSponsorships(r.data));
  }, []);

  const total = sponsorships.reduce((a, s) => a + (s.amount || 0), 0);

  return (
    <div data-testid="sponsor-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-0 border border-border mb-10">
        <div className="p-6 md:border-r border-border">
          <div className="overline text-foreground/60">Active sponsorships</div>
          <div className="font-display text-3xl mt-2">{sponsorships.length}</div>
        </div>
        <div className="p-6 md:border-r border-border">
          <div className="overline text-foreground/60">Total invested</div>
          <div className="font-display text-3xl mt-2">{fmtEUR(total)}</div>
        </div>
        <div className="p-6">
          <div className="overline text-foreground/60">Golfers backed</div>
          <div className="font-display text-3xl mt-2">{new Set(sponsorships.map((s) => s.athlete_id)).size}</div>
        </div>
      </div>

      <div className="overline mb-4">Your sponsorship portfolio</div>
      {sponsorships.length === 0 ? (
        <div className="border border-border p-8 text-foreground/60">
          You haven't sponsored anyone yet. <Link to="/golfers" className="text-primary underline">Browse golfers</Link> to find your first partnership.
        </div>
      ) : (
        <ul className="divide-y divide-border border-y border-border" data-testid="sponsor-portfolio">
          {sponsorships.map((s) => (
            <li key={s.sponsorship_id} className="py-5 grid grid-cols-1 md:grid-cols-12 gap-3 items-center">
              <div className="md:col-span-4">
                <div className="font-display text-2xl">{s.company_name}</div>
                <div className="text-xs text-foreground/60">{s.contact_email}</div>
              </div>
              <div className="md:col-span-3">
                <div className="overline">Frequency</div>
                <div className="mt-1 capitalize">{s.type || "one-off"}</div>
              </div>
              <div className="md:col-span-3">
                <div className="overline">Amount</div>
                <div className="font-display text-xl mt-1">{fmtEUR(s.amount)}</div>
              </div>
              <div className="md:col-span-2 text-right">
                <span className="text-xs uppercase tracking-wider px-2 py-1 bg-primary text-primary-foreground">{s.status}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
